import { Component, OnInit } from '@angular/core';

import { AuthService } from '../auth/auth.service';
import { UserDataService } from './user-data.service';
import {ActivatedRoute, Router} from '@angular/router';
import { MailCenterService } from '../mail-center/mail-center.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})

export class FeaturesComponent implements OnInit {

  users:any;
  companies:any;
  attornies:any;
  projects:any;
  rdCenters:any;
  userskeys:any;
  error="";
  token="";
  record:string="";
  userWithToken:any;
  inventorAdded=false;
  CompanyAdded=false;
  AttorneyAdded=false;
  projectAdded=false;
  rdCenterAdded=false;
  inventor:Array<{name: string, adress: string, mail:string, identity:string, status:string, share:number, inventorsCompany:string,inventorsCompanyAdress:string }>=[];
  company:Array<{name: string, adress: string,  identity:string,  share:number }>=[];
  attorney:Array<{name: string, adress: string,  identity:string }>=[];
  project:Array<{projectCode: string, projectDetail: string}>=[];
  rdCenter:Array<{centerName: string}>=[];
  visibleCompany=false;
  visibleInventor=false;
  visibleAttorney=false;
  visibleProjects=false;
  visibleRDCenter=false;
  searchText:any;
  status:any=[];
  docLink:any=[];
  patentInfo:any;
  visibility=true;
  loggedUser="";

  documentNumber="";
  inventionName="";
  inventionDate:any;
  constructor(private userData:UserDataService, private auth:AuthService, private route:Router, private activatedRoute:ActivatedRoute, private mailService:MailCenterService ){}




    ngOnInit() {

      this.token=this.auth.token;
      this.loggedUser=this.auth.userMail;
     }




  findInventor() {
   this.visibleInventor=!this.visibleInventor;

   this.userData.fetchInventor(this.token).subscribe(
    (res: any) => {
     if (!res) {
       this.record="Buluş Sahibi kaydı bulunamadı";
       alert("Buluş Sahibi kaydı bulunamadı");
     } else {

     //console.log(res);
     this.userWithToken=res;
     this.users = Object.keys(res).map((key) =>
     { return res[key] });

     this.users.key = Object.keys(res).map((key) =>
     { return (key) });

    // console.log(this.users);
     this.record=""
   }},err=>this.error=(err.statusText)
 );
 }
 findCompany() {
  this.visibleCompany=!this.visibleCompany;
  this.userData.fetchCompany(this.token).subscribe(
   (res: any) => {
    if (!res) {
      this.record="Başvuru Sahibi kaydı bulunamadı";
      alert("Başvuru Sahibi kaydı bulunamadı");
    } else {

   // console.log(res);
    this.userWithToken=res;
    this.companies = Object.keys(res).map((key) =>
    { return res[key] });

    this.companies.key = Object.keys(res).map((key) =>
    { return (key) });

    //console.log(this.companies);
    this.record=""
  }},err=>this.error=(err.statusText)
);
}
findAttorney() {
  this.visibleAttorney=!this.visibleAttorney;
  this.userData.fetchAttorney(this.token).subscribe(
   (res: any) => {
    if (!res) {
      this.record="Vekil kaydı bulunamadı";
      alert("Vekil kaydı bulunamadı");
    } else {


    this.userWithToken=res;
    this.attornies = Object.keys(res).map((key) =>
    { return res[key] });

    this.attornies.key = Object.keys(res).map((key) =>
    { return (key) });


    this.record=""
  }},err=>this.error=(err.statusText)
);
}
findProjects()  {
  this.visibleProjects=!this.visibleProjects;
  this.userData.fetchProjects(this.token).subscribe(
   (res: any) => {
    if (!res) {
      this.record="Proje kaydı bulunamadı";
      alert("Proje kaydı bulunamadı");
    } else {


    this.userWithToken=res;
    this.projects = Object.keys(res).map((key) =>
    { return res[key] });

    this.projects.key = Object.keys(res).map((key) =>
    { return (key) });


    this.record=""
  }},err=>this.error=(err.statusText)
);
}
findRDCenters()  {
  this.visibleRDCenter=!this.visibleRDCenter;
  this.userData.fetchRDCenter(this.token).subscribe(
   (res: any) => {
    if (!res) {
      this.record="Ar-Ge Merkezi kaydı bulunamadı";
      alert("Ar-Ge Merkezi kaydı bulunamadı");
    } else {


    this.userWithToken=res;
    this.rdCenters = Object.keys(res).map((key) =>
    { return res[key] });

    this.rdCenters.key = Object.keys(res).map((key) =>
    { return (key) });


    this.record=""
  }},err=>this.error=(err.statusText)
);
}
 getInventor(i:number) {
  // this.inventor.push({name:this.users[i].inventorName[0], adress:this.users[i].inventorAdress[0], mail: this.users[i].inventorMail[0]});
  this.visibleInventor=false;
  for (const element of this.users[i]) {
   this.inventor.push({name:element.inventorName, adress:element.inventorAdress, mail: element.inventorMail, identity:element.inventorIdentityNo, status:element.inventorStatus, inventorsCompany:element.inventorsCompany.name,inventorsCompanyAdress:element.inventorsCompany.adress, share:0});
   //console.log(this.inventor);
   this.inventorAdded=true;
  }
 }
 getCompany(i:number) {
  // this.inventor.push({name:this.users[i].inventorName[0], adress:this.users[i].inventorAdress[0], mail: this.users[i].inventorMail[0]});
  this.visibleCompany=false;
  //console.log(this.companies)
  for (const element of this.companies[i]) {
   this.company.push({name:element.CompanyName, adress:element.CompanyAdress,  identity:element.CompanyIdentityNo,  share:0});
   //console.log(this.company);
   this.CompanyAdded=true;
  }
 }
 getAttorney(i:number) {
  // this.inventor.push({name:this.users[i].inventorName[0], adress:this.users[i].inventorAdress[0], mail: this.users[i].inventorMail[0]});
  this.visibleAttorney=false;
 console.log (this.attorney, this.attornies);

  //console.log(this.companies)
  for (const element of this.attornies[i]) {
   this.attorney.push({name:element?.AttorneyName, adress:element?.AttorneyAdress,  identity:element?.AttorneyIdentityNo});
   //console.log(this.company);
   this.AttorneyAdded=true;
  }
 }
 getProjects(i:number) {
  // this.inventor.push({name:this.users[i].inventorName[0], adress:this.users[i].inventorAdress[0], mail: this.users[i].inventorMail[0]});
  this.visibleProjects=false;
 console.log (this.project, this.projects);

  //console.log(this.companies)
  for (const element of this.projects[i]) {
   this.project.push({projectCode:element?.projectCode, projectDetail:element?.projectDetail});
  this.projectAdded=true;
  }
 }
 getRDCenters(i:number) {
  // this.inventor.push({name:this.users[i].inventorName[0], adress:this.users[i].inventorAdress[0], mail: this.users[i].inventorMail[0]});
  this.visibleRDCenter=false;
 console.log (this.rdCenter, this.rdCenters);

  //console.log(this.companies)
  for (const element of this.rdCenters[i]) {
   this.rdCenter.push({centerName:element?.centerName});
  this.rdCenterAdded=true;
  }
 }
 deleteInventors() {
  this.inventor=[];
  this.inventorAdded=false;
}
  deleteCompanys() {
  this.company=[];
  this.CompanyAdded=false;
}
deleteAttornies() {
  this.attorney=[];
  this.AttorneyAdded=false;
}
deleteProjects() {
  this.project=[];
  this.projectAdded=false;
}
deleteRDCenters() {
  this.rdCenter=[];
  this.rdCenterAdded=false;
}
 submit() {
  this.inventionName=this.inventionName?.toLowerCase();
  this.status.push({status:"taslak buluş", date:Date.now(), recordigUser:this.loggedUser});
  this.visibility=!this.visibility;
  /*console.log((this.company,
    this.inventionRecord.controls.documentNumber.value,
    this.inventionRecord.controls.inventionName.value,
    this.inventionRecord.controls.inventionDate.value,
    this.inventor,
    this.status
    ));*/
  this.userData.addUser(this.company,
                        this.attorney,
                        this.rdCenter,
                        this.project,
                        this.documentNumber,
                        this.inventionName,
                        this.inventionDate,
                        this.inventor,
                        this.status,
                        this.docLink,
                        this.patentInfo
                        ).subscribe(
                          arr=>{
                            const time=(Math.round(Date.now()/1000));
                            const date = new Date(this.inventionDate);
                            const unixTimestamp = Math.floor(date.getTime() / 1000);
                            const reminder= [unixTimestamp, unixTimestamp+2628000,unixTimestamp+3942000, unixTimestamp+4599000 ]  // Buluş tarihinden 1 Ay, 1,5 ay, 1,75 ay sonra
                            this.mailService.demandforrightReminder(this.inventionDate,this.inventionName, this.status, reminder).pipe(first())
                              .subscribe((resp: any) => {
                                console.log({ resp });

                                alert("15 gün, 1 ay ve 1,5 ay sürelerinde karar girişinin yapılması için hatırlatma yapılacaktır")
                              }, (err: any) => {
                                console.error({ err });

                              });


                            console.log(arr);
                          this.error="Patent Kaydı Yapıldı";
                          alert("Patent Kaydı Yapıldı");
                          this.route.navigate(['../patentList'], { relativeTo: this.activatedRoute });
                        },
                        err=>{
                        this.error=err.statusText;
                        console.log(this.error)});
                        this.users=[];


}

  }




